import React from 'react'
import styled from 'styled-components'
import VisitUsSection from './components/VisitUsSection';

const Wrapper = styled.div``;

function ContactPage() {
  return (
    <Wrapper>
      <VisitUsSection/>
    </Wrapper>
  )
}

export default ContactPage
